import React, { useState } from "react";
import styles from "./Paymetns.module.scss";
import CustomButton from "../../CustomButton/CustomButton";
import PaymentsTable from "../../Tables/PaymentsTable/PaymentsTable";
import PaymentsModal from "./PaymentsModal/PaymentsModal";
import { useTranslation } from "react-i18next";

const Payments = () => {
  const { t } = useTranslation();
  const [modal, setModal] = useState(false);
  return (
    <div className={styles.payments}>
      <div className={styles.paymentsHeader}>
        <div className={styles.header}>
          <div className={styles.headerTitle}>
            <h1 className={styles.title}>{t("payments.trialPeriod")}</h1>
            <span className={styles.status}>{t("payments.activeStatus")}</span>
          </div>
          <CustomButton blue width="200px" onClick={() => setModal(true)}>
            {t("payments.updatePlanButton")}
          </CustomButton>
        </div>
        <div className={styles.paymentInfo}>
          <p className={styles.price}>{t("payments.price")}</p>
          <span className={styles.paymentDate}>
            {t("payments.nextPaymentDate")}
          </span>
        </div>
        <div className={styles.messagesInfo}>
          <h4 className={styles.messageTitle}>
            {t("payments.requestsForTariff")}
          </h4>
          <p className={styles.messageText}>
            {t("payments.usedMessages")}{" "}
            <span className={styles.messageSpan}>
              {t("payments.messageCount")}
            </span>
          </p>
        </div>
        <button className={styles.cancelButton}>
          {t("payments.cancelSubscription")}
        </button>
      </div>
      <PaymentsTable />
      {modal && <PaymentsModal setModal={setModal} />}
    </div>
  );
};

export default Payments;
